module.exports = __webpack_public_path__ + "media/images/menu/sinope-9fb7a0aa7dde6e9d52ec54f76084eae1.jpg";